// Module
var code = "<label class=\"componentRoot\"> <span *ngIf=\"!isDone\"> <span>{{timerDescription | translate}}: </span> <span class=\"time-style\">{{formattedTime}}</span> </span> <span *ngIf=\"isDone\">{{timerOverMessage | translate}}</span> </label>";
// Exports
module.exports = code;